import PouchDB from "pouchdb";
import { useCallback, useState } from "react";
import { useDatabases } from "./useDatabases";
import { DatabaseIdentifier } from "./manager";
import { useHandlePouchChanges } from "./useHandlePouchChanges";

interface PouchDeleteReturn {
  execute: (doc: PouchDB.Core.RemoveDocument) => Promise<PouchDB.Core.IdMeta & PouchDB.Core.RevisionIdMeta>;
  deleting: boolean;
  error: unknown | null;
}

function usePouchDelete<T>(database: PouchDB.Database<T> | undefined, dependencies: DatabaseIdentifier[]): PouchDeleteReturn {
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState<unknown | null>(null);

  const handlePouchChanges = useHandlePouchChanges();

  const execute = useCallback(
    async (doc: PouchDB.Core.RemoveDocument) => {
      if (!database) {
        throw new Error("Database not available");
      }
      try {
        setDeleting(true);
        setError(null);
        console.log("[POUCH GET]", database.name, doc);
        const resp = await database.remove(doc);
        handlePouchChanges(dependencies).then(() => {});
        return { _id: resp.id, _rev: resp.rev };
      } catch (e) {
        setError(e);
        throw e;
      } finally {
        setDeleting(false);
      }
    },
    [database, dependencies, handlePouchChanges]
  );

  return { deleting, error, execute };
}

export function useDeleteProject() {
  const { projects } = useDatabases();
  return usePouchDelete(projects, ["projects"]);
}

export function useDeleteSetting() {
  const { settings } = useDatabases();
  return usePouchDelete(settings, ["settings"]);
}

export function useDeleteFormTemplate() {
  const { formTemplates } = useDatabases();
  return usePouchDelete(formTemplates, ["formTemplates"]);
}
